import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { DocumentRefService } from './document-ref.service';
import { WindowRefService } from './window-ref.service';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

const API_PATH = environment.apiPath;

@Injectable({
  providedIn: 'root'
})
export class ConsumeRestApiService {
  private API_URL: string;

  constructor(private http: HttpClient,
    private documentRef: DocumentRefService,
    private windowRef: WindowRefService) {
    this.API_URL = this.getHOSTURL(API_PATH);
  }

  public getData(locale: string) {
    // const recordLocator =  'MOCKPNR'; // sessionStorage.getItem('recordLocator_data');
    // const firstName = 'abc'  //sessionStorage.getItem('firstName_data');
    // const lastName =  'def'  //sessionStorage.getItem('lastName_data');

    const recordLocator =   sessionStorage.getItem('recordLocator_data');
    const firstName = sessionStorage.getItem('firstName_data');
    const lastName =  sessionStorage.getItem('lastName_data');

    if (recordLocator === 'MOCKPNR') {

      return this.http.get('assets/MOCKPNR.json').pipe(
        map(res => {
          return res;
        }));
    } else {
      const body = {
        'recordLocator': recordLocator,
        'firstName': firstName,
        'lastName': lastName,
        'locale': locale
      };
      return this.http.post(API_PATH, body).pipe(
        map(res => {
          return res;
        }));
    }
  }

  private getHOSTURL(path) {
    const protocol = this.windowRef.nativeWindow.location.protocol;
    const hostName = this.windowRef.nativeWindow.location.hostname;
    let port = this.windowRef.nativeWindow.location.port;
    port = ((port) && (port.length > 0)) ? ':' + port : '';

    if (hostName === 'localhost') {
      return path;
    } else {
      return protocol + '/'  + path;
    }
  }
}
